module.exports = __webpack_public_path__ + "static/media/Obrazec na pulnomoshtno.5ffede6e.doc";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Obrazec na pulnomoshtno.doc
// module id = 133
// module chunks = 0